export const getImagePath = (imageUrl: string): string => {
    const imageUrlObject = new URL(imageUrl)

    if (process.env.NODE_ENV === 'development') {
        imageUrlObject.port = '8000'
    }
    // } else if (process.env.NODE_ENV === 'production') {
    //     imageUrlObject.port = '443'
    // }
    return imageUrlObject.toString()
}
